import { ModuleWithProviders, NgModule } from '@angular/core';
import { LocalCacheService, LocalCacheMode } from './local-cache.service';

@NgModule({
    declarations: [],
    exports: []
})
export class LocalCacheModule {

    static forRoot(config: LocalCacheMode): ModuleWithProviders {
        return {
            ngModule: LocalCacheModule,
            providers: [
                { provide: LocalCacheMode, useValue: config }
            ]
        };
    }

}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/core/local-cache/local-cache.module.ts